// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function setPage(data) {
  return {
    type: types.SET_CURRENT_PAGE,
    data
  };
}
